/**
 * Slider Mobile Filters - show/hide Type/Date filters at mobile
 *
 * @author Matt Haynes <matthew.haynes@joipolloi.com>
 * @package The University of Sheffield - Performance Venues
 */

const SlideMobileFilters = () => {
    const filtersList = document.getElementById('filtersList');
    if (!filtersList) return;

    const filtersToShow = Array.from(document.querySelectorAll('.filterToShow'));
    const showFilterButtons = Array.from(document.querySelectorAll('.showFilter'));
    showFilterButtons.forEach(button => {
        button.addEventListener('click', e => {
            e.preventDefault();

            const el = button.dataset.filter;
            filtersToShow.forEach(filterToShow => {
                const filterEl = filterToShow.dataset.filtertoshow;
                if (el === filterEl) {
                    if (filterToShow.classList.contains('active')) {
                        filterToShow.classList.remove('active');
                    } else {
                        filterToShow.classList.add('active');
                    }
                } else {
                    filterToShow.classList.remove('active');
                }
            });
        });
    });
};

export default SlideMobileFilters;
